import React from 'react';
import { PsPage } from '../../../shared/components/ps-page/PsPage';
import { I18nUtils } from '../../../../i18n/I18nUtils';
import { ContractorListCard } from './ContractorListCard';
import { BreadcrumbsManagerInstance } from '../../../shared/breadcrumbs/BreadcrumbsManager';
import { Breadcrumbs } from '../../../shared/breadcrumbs/Breadcrumbs';
import { CardStorageManager } from '../../../shared/utils/CardStorageManager';

export class ContractorListScreen extends React.Component {

    cardStorageManager = new CardStorageManager(this.props.location.pathname);

    constructor(props) {
        super(props);

        this.cardStorageManager.init();

        BreadcrumbsManagerInstance.build([
            Breadcrumbs.MY_CONTRACTORS,
        ]);

        this.state = {
            breadcrumbs: BreadcrumbsManagerInstance.breadcrumbs(),
        };
    }

    render() {
        const { breadcrumbs } = this.state;

        return (
            <PsPage title={I18nUtils.tr('TR_MIS_CONTRATISTAS')} breadcrumbs={breadcrumbs}>
                <ContractorListCard
                    saveCardState={this.saveCardState}
                    initialCardState={this.readCardState()}
                />
            </PsPage>
        );
    }

    saveCardState = (state) => {
        this.cardStorageManager.saveCard('myContractors', state);
    };

    readCardState = () => {
        return this.cardStorageManager.readCard('myContractors');
    };
}



// WEBPACK FOOTER //
// ./src/app/my-contractors/contractor/list/ContractorListScreen.jsx